export namespace Wording {

  export const LANG_UNSUPPORTED = 'This language is not supported for transcription, but you can still use the call feature.';

}
